import { MdSearch } from 'react-icons/md';

import TabFilters from '@/components/common/TabFilters';
import SafeInput from '@/components/inputs/SafeInput';
import useLanguage from '@/utils/hooks/useLanguage';
import useMarketList from '@/utils/hooks/useMarketList';

export interface MarketListProps {
    isTraderMode?: boolean;
    onClick?: () => void;
}

export enum MarketListFilter {
    'All' = 0,
    'FX' = 1,
    'Crypto' = 2,
    'Index CFD' = 3,
    'Comm CFD' = 4,
    'Futures CFD' = 5
}

export default function MarketList(props: MarketListProps) {
    const {
        marketListFilters,
        marketListFilter,
        setMarketListFilter,
        setFilter,
        hasInstruments: {
            hasFxInstruments,
            hasCryptoInstruments,
            hasIndexInstruments,
            hasCommInstruments,
            hasFuturesInstruments
        },
        VirtualizedList
    } = useMarketList(props);

    const lang = useLanguage();

    return (
        <div className="h-full w-full flex flex-col">
            <TabFilters.Main>
                <TabFilters.Filter
                    selectedFilter={marketListFilter}
                    setSelectedFilter={setMarketListFilter}
                    filter={marketListFilters[0]}
                />
                {hasFxInstruments && (
                    <TabFilters.Filter
                        selectedFilter={marketListFilter}
                        setSelectedFilter={setMarketListFilter}
                        filter={marketListFilters[1]}
                    />
                )}
                {hasCryptoInstruments && (
                    <TabFilters.Filter
                        selectedFilter={marketListFilter}
                        setSelectedFilter={setMarketListFilter}
                        filter={marketListFilters[2]}
                    />
                )}
                {hasIndexInstruments && (
                    <TabFilters.Filter
                        selectedFilter={marketListFilter}
                        setSelectedFilter={setMarketListFilter}
                        filter={marketListFilters[3]}
                    />
                )}
                {hasCommInstruments && (
                    <TabFilters.Filter
                        selectedFilter={marketListFilter}
                        setSelectedFilter={setMarketListFilter}
                        filter={marketListFilters[4]}
                    />
                )}
                {hasFuturesInstruments && (
                    <TabFilters.Filter
                        selectedFilter={marketListFilter}
                        setSelectedFilter={setMarketListFilter}
                        filter={marketListFilters[5]}
                    />
                )}
            </TabFilters.Main>
            <div className="p-2">
                <SafeInput
                    placeholder={lang.common.search}
                    icon={<MdSearch />}
                    onChange={(e) => setFilter(e.target.value)}
                />
            </div>

            <div className="relative self-stretch grow basis-full">
                <VirtualizedList />
            </div>
        </div>
    );
}
